export const HomePageActionTypes = {
    GET_HOME_PAGE_DATA: "GET_HOME_PAGE_DATA",
    GET_HOME_TRAINING_DATA: "GET_HOME_TRAINING_DATA",
    WEBINAR_HOME_PAGE_DATA: "WEBINAR_HOME_PAGE_DATA",
    CLASSROOM_HOME_PAGE_DATA: "CLASSROOM_HOME_PAGE_DATA",
    SEMINAR_HOME_PAGE_DATA: "SEMINAR_HOME_PAGE_DATA"
};